import { render, staticRenderFns } from "./flowChange.vue?vue&type=template&id=6000025a&"
import script from "./flowChange.vue?vue&type=script&lang=js&"
export * from "./flowChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports